<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading">
    <div class="banner">
      <button type="button" class="back-button" (click)="reroute()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span class="back-text">Tillbaka</span>
      </button>
    </div>

    <div class="contents-wrapper">
      <div class="contents-container">
        <div class="page-icon">
          <app-zaver-icon [size]="80" name="mailCircle" ></app-zaver-icon>
        </div>

        <div class="page-text">Vänligen ange din e-post</div>

        <zaver-alert-box
          *ngIf="shouldDisplayEmailError"
          [messageList]="emailErrorMessages"
          type="WARNING"
        ></zaver-alert-box>

        <form [formGroup]="form">
          <div class="input-container">
            <zaver-animated-form-input
              [size]="'large'"
              [placeholder]="'E-postadress'"
              [formControlName]="'email'"
              [error]="form.controls.email.invalid && showError"
              [errorMessage]="'Vänligen ange en giltig e-postadress'"
              [inputMode]="'email'"
              [autoComplete]="'email'"
              [inputType]="'email'"
              [errorIcon]="'assets/icon/icon_error.svg'"
            ></zaver-animated-form-input>
          </div>
          <div class="input-container">
            <zaver-animated-form-input
              [ariaLabel]="'Ange telefonnummer'"
              [formControlName]="'phone'"
              [error]="form.controls.phone.invalid && showError"
              (onKeyboardEnter)="handleCtaClick()"
              inputMode="tel"
              placeholder="Mobilnummer"
              errorMessage="Vänligen ange ett giltigt mobilnummer (07******* eller +***********)"
            >
            </zaver-animated-form-input>
          </div>
        </form>

        <div class="pr-info" *ngIf="paymentRequest">
          <label>Totalbelopp</label>
          <label>
            {{
              paymentRequest.amount.toLocaleString('sv', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            }}
            SEK
          </label>
        </div>

        <zaver-primary-button text="Godkänn" (click)="handleCtaClick()">
        </zaver-primary-button>
        <app-se-terms
          *ngIf="!!paymentRequest.specificPaymentMethod"
          [paymentRequest]="paymentRequest"
        ></app-se-terms>
      </div>
    </div>
  </div>
</div>
